export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Развитие управленческих компетенций руководителей и менеджеров",
        "description": "Развитие управленческих компетенций руководителей и менеджеров: лидерство, делегирование, постановка задач, обратная связь, переговоры, мотивация и управление изменениями. Корпоративные программы.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Развитие управленческих компетенций",
        "description": "Корпоративные программы развития управленческих компетенций руководителей и менеджеров: лидерство, постановка задач, делегирование, контроль, обратная связь, мотивация, коммуникация, управление конфликтами, принятие решений, переговоры, управление изменениями и развитие сотрудников. Диагностика, обучение, практика, внедрение и сопровождение.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "развитие управленческих компетенций, обучение руководителей, обучение менеджеров, развитие руководителей, корпоративное обучение руководителей",
        "url": "https://business-training.by/menedzhment-i-liderstvo/razvitie-upravlencheskih-kompetenciy"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое управленческие компетенции?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Это не набор теоретических знаний о менеджменте, а способность руководителя применять конкретные инструменты управления в реальных рабочих ситуациях и получать необходимый результат через команду. Знать инструмент и уметь применять его — не одно и то же, поэтому развитие компетенций включает обучение, практику, внедрение и обратную связь."
            }
          },
          {
            "@type": "Question",
            "name": "Какие компетенции должен развивать руководитель?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Лидерство, постановку задач, делегирование, контроль, обратную связь, мотивацию, коммуникацию, управление конфликтами, принятие решений, переговоры, управление изменениями и развитие сотрудников. Конкретный набор приоритетных компетенций определяется задачей компании и управленческой ролью."
            }
          },
          {
            "@type": "Question",
            "name": "Как определить слабые управленческие компетенции?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через диагностику: интервью с руководителем и вышестоящим руководством, анализ типичных управленческих ситуаций, обратную связь от сотрудников, оценку компетенций, анализ повторяющихся проблем, наблюдение за совещаниями и разбор реальных кейсов. Конкретный набор инструментов определяется задачей компании."
            }
          },
          {
            "@type": "Question",
            "name": "Чем развитие управленческих компетенций отличается от обычного тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Тренинг может дать инструменты и изменить понимание проблемы, но устойчивое изменение управленческого поведения требует практики и внедрения. Развитие компетенций — это процесс формирования нового поведения, а не разовая передача знаний, поэтому в нём есть диагностика, практика, внедрение и сопровождение."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько времени занимает развитие управленческих навыков?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Зависит от формата и задачи: корпоративный тренинг занимает 1–3 дня, модульная программа — несколько встреч с практикой между ними, комплексная программа развития — несколько месяцев. Устойчивое изменение поведения формируется постепенно, через применение инструментов в реальной работе."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли разработать программу под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Сначала проводится диагностика: определяем текущий уровень компетенций, реальные управленческие задачи и ожидания бизнеса, затем приоритизируем компетенции и настраиваем программу под отрасль, уровень участников и задачи компании."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли программа для новых руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Для новых руководителей это переход от роли специалиста к роли управленца: постановка задач, делегирование, контроль и обратная связь. Программа адаптируется под уровень участников и помогает быстрее освоить новую управленческую роль."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли развивать компетенции всей управленческой команды?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, работа с управленческой командой формирует единый язык и стандарты управления, что повышает согласованность решений и взаимодействие между подразделениями. Это особенно полезно для компаний, которые масштабируются или формируют кадровый резерв."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить обучение онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу: корпоративный тренинг, модульная программа, бизнес-игры, коучинг руководителей, управленческая фасилитация или сопровождение."
            }
          },
          {
            "@type": "Question",
            "name": "Что происходит после обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Руководители переносят инструменты в реальную работу, а при необходимости проводится сопровождение: разбираются реальные ситуации, корректируются подходы и оцениваются изменения в управленческой практике. Обучение не заканчивается тренингом."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить результат развития управленческих компетенций?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через оценку изменений в управленческой практике: стала ли понятнее постановка задач, снизился ли микроменеджмент, улучшилась ли обратная связь, выросла ли самостоятельность команды. Мы определяем, какие изменения произошли в поведении руководителей, а не обещаем гарантированные финансовые показатели."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли сочетать тренинг и сопровождение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, это наиболее эффективный вариант. Тренинг даёт инструменты, а сопровождение помогает закрепить их: разбираем реальные ситуации после обучения, поддерживаем внедрение и корректируем подходы, чтобы компетенции стали частью ежедневной работы."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}